module.exports = __webpack_public_path__ + "static/media/arrow-right.38a2b484.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Support/icons/arrow-right.svg
// module id = 1621
// module chunks = 0